module.exports = __webpack_public_path__ + "img/20231101110304257x8b.03780178.png";